import { Route } from '@angular/router';
import { redirectAssetGuard } from '@mzic/mzic-guard';
import { dynamicLanguageGuard, languageGuard } from './guards/language.guard';
import { AboutComponent } from './pages/about/about.component';
import { AssetComponent } from './pages/asset/asset.component';
import { ContactComponent } from './pages/contact/contact.component';
import { DesktopUnavailableComponent } from './pages/desktop-unavailable/desktop-unavailable.component';
import { InvestorLandingComponent } from './pages/investor-landing/investor-landing.component';
import { MarketComponent } from './pages/market/market.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';

export const mzicIoRoutes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    component: InvestorLandingComponent,
    canActivate: [languageGuard],
  },
  {
    path: 'home',
    component: InvestorLandingComponent,
    canActivate: [dynamicLanguageGuard],
  },
  {
    path: ':lang/home',
    component: InvestorLandingComponent,
    title: 'MZIC - Invest in Music',
  },
  {
    path: 'market',
    component: MarketComponent,
    canActivate: [dynamicLanguageGuard],
  },
  {
    path: ':lang/market',
    component: MarketComponent,
    title: 'MZIC - Market',
  },
  {
    path: 'contact',
    component: ContactComponent,
    canActivate: [dynamicLanguageGuard],
  },
  {
    path: ':lang/contact',
    component: ContactComponent,
    title: 'MZIC - Contact',
  },
  {
    path: 'about',
    component: AboutComponent,
    canActivate: [dynamicLanguageGuard],
  },
  {
    path: ':lang/about',
    component: AboutComponent,
    title: 'MZIC - About',
  },
  {
    path: 'assets/:id',
    component: AssetComponent,
    title: 'MZIC',
    canActivate: [dynamicLanguageGuard],
  },
  {
    path: ':lang/assets/:id',
    component: AssetComponent,
    title: 'MZIC',
  },
  {
    path: 'desktop-download',
    component: DesktopUnavailableComponent,
    title: 'MZIC - App Not Available on Desktop',
    canActivate: [dynamicLanguageGuard],
  },
  {
    path: ':lang/desktop-download',
    component: DesktopUnavailableComponent,
    title: 'MZIC - App Not Available on Desktop',
  },
  {
    path: 'not-found',
    component: NotFoundComponent,
    title: 'MZIC - Page Not Found',
    canActivate: [dynamicLanguageGuard],
  },
  {
    path: ':lang/not-found',
    component: NotFoundComponent,
    title: 'MZIC - Page Not Found',
  },
  {
    path: '**',
    canActivate: [redirectAssetGuard],
    component: NotFoundComponent,
  },
];
